<template>
  <video ref="video" muted playsinline :poster="poster" v-if="isDesktop">
    <source :src="src" type="video/mp4" />
  </video>
</template>

<script>
import { BREAKPOINTS } from '~scripts/core/breakpoints';

export default {
  name: 'SpecialsVideo',
  props: {
    src: String,
    poster: String,
  },
  data() {
    return {
      isDesktop: false,
      observer: null,
      hasPlayed: false,
    };
  },
  computed: {
    breakpoints() {
      return BREAKPOINTS;
    },
    mediaSm() {
      return window.matchMedia(`(max-width: ${this.breakpoints.smMax})`);
    },
  },
  mounted() {
    this.mediaSm.addListener(this.handleMediaChange);
    this.handleMediaChange(this.mediaSm);
    this.$nextTick(() => {
      this.initIntersectionObserver();
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    handleMediaChange(event) {
      this.isDesktop = !event.matches;
    },
    initIntersectionObserver() {
      const video = this.$refs.video;
      if (video) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && !this.hasPlayed) {
                video.play();
                this.hasPlayed = true; 
                this.observer.disconnect();
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.25 }
        );
        this.observer.observe(video);
      }
    },
  },
};
</script>
